import React from 'react';
import Input from '../../../../shared/input';
import Datepicker from '../../../../shared/datepicker';
import SelectCheckbox from '../../../../shared/select-checkbox';


interface IFieldsStep {
    suppliers?: any;
    formData?: any;
    formErrors?: any;
    currencies?: any
    onChangeInput: (value: string | null | undefined, type: string) => void;
    onChangeSelectedValue: (value: string, type?: string) => void;
    onChangeDateInput: (value: string | null | undefined, type: string) => void;
}

const FieldsStep = ({
    suppliers,
    formData,
    formErrors,
    currencies,
    onChangeDateInput,
    onChangeInput,
    onChangeSelectedValue,
}: IFieldsStep) => {
    return (
        <div className='bg-white p-3 border-b-2 border-[#e4e4e4]'>
            <p className='font-bold mb-2'>Purchase Details</p>
            <p className='mb-4'>Please fill details on form below.</p>
            <div className={'grid grid-cols-4 gap-4'}>
                <SelectCheckbox
                    name='Supplier'
                    placeholder=' '
                    containerStyle='mb-0'
                    options={suppliers || []}
                    selectedOption={formData?.supplier}
                    onChangeSelectedOption={onChangeSelectedValue}
                    uniqueName={'supplier'}
                    error={formErrors?.supplier}
                />
                <Input
                    label='Supplier Email'
                    placeholder=' '
                    disabled={true}
                    containerStyle='mb-0'
                    showValue={true}
                    inputValue={formData?.supplier?.email}
                />
                <Datepicker
                    label='Expected Delivery'
                    placeholder=' '
                    containerStyle='mb-0'
                    inputValue={formData?.expectedDeliveryDate}
                    onChangeInput={onChangeDateInput}
                    inputUniqueName={'expectedDeliveryDate'}
                    error={formErrors?.expectedDeliveryDate}
                />
                <Input
                    label='Shipping Costs'
                    placeholder=' '
                    containerStyle='mb-0'
                    inputValue={formData?.shippingCosts}
                    onChangeInput={onChangeInput}
                    showValue={true}
                    inputUniqueName={'shippingCosts'}
                    error={formErrors?.shippingCosts}
                />
                <SelectCheckbox 
                    name='Currency'
                    placeholder=' '
                    containerStyle='mb-0'
                    options={currencies || []}
                    selectedOption={formData?.currency}
                    onChangeSelectedOption={onChangeSelectedValue}
                    uniqueName={'currency'}
                    error={formErrors?.currency}
                />
            </div>
        </div>
    )
}
export default FieldsStep;